/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import {WorkflowExternalDefDtoModel} from "./workflow-external-def-dto.model";

export class WorkflowExternalStepDefDtoModel extends JSONable {
    workflowDefinitionUuid: string | null = null;
    workflowExternalDefDto: WorkflowExternalDefDtoModel | null = null;
    stepId: string | null = null;
    systemName: string | null = null;

    static createWorkflowExternalStepDefDtoModel(workflowDefinitionUuid: string | null, stepId: string | null, systemName: string | null) {
        const step = new WorkflowExternalStepDefDtoModel();
        step.workflowDefinitionUuid = workflowDefinitionUuid;
        step.stepId = stepId;
        step.systemName = systemName;
        return step;
    }

    static createWorkflowStepVoModel(stepId: string | null, systemName: string | null) {
        const workflow = new WorkflowExternalStepDefDtoModel();
        workflow.stepId = stepId;
        workflow.systemName = systemName;
        return workflow;
    }
}
